/**
 * Simple CSS Transition based fading gallery.
 *
 * @param {HTMLElement} element
 * @param time
 * @return {{destroy: destroy}}
 */
export default function FadingGallery(element, time = 4000) {
    let items = [];
    let index = 0;
    let interval = null;

    constructor();

    function constructor() {
        find_elements();
        index = get_current_index();

        add_events();

        element.classList.add('is-init');
    }

    function add_events() {
        interval = setInterval(next, time);
        element.addEventListener('click', next);
    }

    function remove_events() {
        clearInterval(interval);
        element.removeEventListener('click', next);
    }

    function find_elements() {
        items = Array.from(element.children);
    }

    function get_current_index() {
        for (let i = 0; i < items.length; ++i) {
            if (items[i].classList.contains('is-current')) {
                return i;
            }
        }

        return 0;
    }

    function next() {
        items[index].classList.remove('is-current');

        if (++index >= items.length) {
            index = 0;
        }

        items[index].classList.add('is-current');
    }

    function destroy() {
        remove_events();
    }

    return {
        destroy
    }
}